import React, { useEffect } from "react";
import Card from "react-bootstrap/Card";

import Button from "react-bootstrap/Button";
import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

import pdf from "../../Assets/Flyer.pdf";
import {  pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// Set up PDF.js worker from CDN
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function SupportCard() {

   const location = useLocation();// Initialize location
  //  const navigate = useNavigate(); // Initialize navigate
  
    const handleClick = () => {
    window.open("https://www.favrhood.com/"); // This will navigate to the "/another-page" route
    };
    const handleClick_1 = () => {
      window.open("https://docs.google.com/forms/d/1EPH7BwasKW3g_4OGmO171Wuho5EvoNznMCkFEA7q5Ok/edit"); // This will navigate to the "/another-page" route
    };
    const handleClick_2 = () => {
      window.open("https://docs.google.com/forms/d/1Q2Lc15IwomBIFeSAxIfsK56xI3vkCjvKW8yXQcWQvmM/edit"); // This will navigate to the "/another-page" route
    };
    const handleClick_3 = () => {
     window.open("https://docs.google.com/forms/d/1iwEzu53wDAe41RjEDe-gHIX9H61QikSfR2RKmyCBp_M/edit"); // This will navigate to the "/another-page" route
    };
    // const handleClick_4 = () => {
    //   navigate("/share"); // This will navigate to the "/another-page" route
    // };

   useEffect(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [location]);
  
  return (
    <Card className="quote-card-view">
      <Card.Body>
        {/* <blockquote className="blockquote mb-0"> */}
          <p className="about-text">
            <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Building and Connecting<strong className="purple"> Communities</strong> with Technology
            </h4>
          Choicest Fruit® is reimagining what community impact looks like. Through hands-on tech education and
           our new neighborhood platform <strong className="purple">Favrhood</strong>, we empower people to build projects, share skills, and support
            local entrepreneurship, right where they live. Whether you’re a student, mentor, local business owner,
             or community champion, there’s a place for you in our growing ecosystem.
          </p>

          <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Introducing Favrhood <strong className="purple">Your Neighborhood</strong> Innovation Hub
            </h4>
           Favrhood is a community platform built by Choicest Fruit that helps neighbors:
           <br/>
           <li>Build and collaborate on local projects</li>
            <li>Share skills, resources, discover and share talents and services</li>
            <li>Join or start clubs around tech, arts, learning, sustainability, home improvement, and more</li>
            <li>Support local entrepreneurs and small businesses</li>
            <li>Get tech help, mentorship, and real-world experience</li>
            <li>Access tech education and training opportunities</li>
            <li>Connect with mentors and community leaders</li>
          <br/>
            Favrhood is more than just an app – it’s a movement to harness the power of technology for positive social impact,
             starting right in our own neighborhoods. Favrhood brings community building into one simple place, turning everyday
              ideas into meaningful neighborhood impact. Join us in creating vibrant, connected communities where everyone can thrive.
          </p>
            <br/>
            <br/>
         <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            How Favrhood <strong className="purple">Changes</strong> Community Engagement
            </h4>
           <b className="purple">Connect With Your Community</b>
           <br/> 
           Favrhood is neighborhood-based, helping people connect with those who live and work nearby. Whether you’re launching a 
           community garden, building an app, fixing homes, or offering freelance services, Favrhood keeps opportunities local.          
           <br/>
           <br/>
           <b className="purple">Create Projects & Join Clubs</b>
           <br/> 
           Post a project, invite volunteers or mentors, share resources, or promote your work. Form clubs around shared
            interests, from robotics and web design to arts, service, and sustainability.
            <br/>
           <br/>
           <b className="purple">Built to Scale Anywhere</b>
           <br/> 
           Favrhood is designed to grow with your community. It’s a space where trust, collaboration, and shared skills turn
            ideas into real impact, strengthening neighborhoods one connection at a time.
          </p>
            <br/>
            <br/>

            <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Why Your <strong className="purple"> Support</strong> Matters
            </h4>
           Your involvement fuels a powerful ecosystem where technology, education, and community come together.
           When you support Choicest Fruit, you help:
           <br/>
           <li><b className="purple">Empower Youth Leaders </b> – Strengthen our Ambassador Fellowship so youth can mentor peers, lead projects, and innovate locally.</li>
            <li><b className="purple">Empower Communities </b>– Deliver training, tools, and platforms like Favrhood to underserved neighborhoods.</li>
            <li><b className="purple">Transform Lives </b>– Open pathways into software, robotics, ethical tech, and entrepreneurship.</li>
            <li><b className="purple">Bridge the Digital Divide </b>– Ensure seniors and marginalized communities aren’t left behind.</li>
            <li><b className="purple">Foster Social Change </b>– Support initiatives like Code & Soil, where tech meets community action.</li>                        
         
          </p>
            <br/>
            <br/>
        
          <p className="about-text">
          <h4 style={{ fontSize: "1.5em", paddingBottom: "20px" }}>
            Ways <strong className="purple">You Can</strong> Get Involved
            </h4>
            Your support is crucial in helping us achieve our mission. Here’s how you can get involved:
            <br />
            <br />
            <ol><b className="purple">Join Favrhood:</b> Create your profile, start a project, join a club, or offer your skills as a mentor, volunteer, or local entrepreneur.<Button onClick={handleClick}     
      >Join Favrhood</Button></ol>
            <ol><b className="purple">Sponsor a Program or Participant: </b> Help fund youth, seniors, and community members gaining access to life-changing tech education.<Button onClick={handleClick_1}     
      >Sponsor</Button></ol>
            <ol><b className="purple">Volunteer Your Time: </b>Mentor students, teach workshops, or support local innovation projects.<Button onClick={handleClick_2}     
      >Volunteer</Button></ol>
            <ol><b className="purple">Partner with Us: </b> If you represent a business, nonprofit, or institution, collaborate with us to expand community-powered tech access.<Button onClick={handleClick_3}     
      >Partner</Button></ol>
             <ol><b className="purple">Spread the Word:</b> Invite your network to join Favrhood and support Choicest Fruit — because community impact grows through connection.
             <Button 
              href={pdf}
                         target="_blank"     
      >Download and Share</Button ></ol> 
          </p>

          {/* <footer className="blockquote-footer"></footer>
        </blockquote> */}
      </Card.Body>
    </Card>
  );
}

export default SupportCard;
